import { isLocalApp } from './isLocalApp';
import { isInContainer } from './isInContainer';

export const isStandalone = (): boolean => isLocalApp() && !isInContainer();
